import {
  CLEAR_STUDENT_DATA,
  FETCH_STUDENT_SENT,
  FETCH_STUDENT_SUCCEEDED,
  FETCH_STUDENT_FAILED,
} from '../../actions/student';

const initialState = {
  id: null,
  loading: false,
  student: null,
  onlineStatus: false,
};

export default function studentDataReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_STUDENT_DATA:
      return initialState;
    case FETCH_STUDENT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        student: payload.user,
        id: payload.user.id,
        onlineStatus: payload.online_status.online,
      };
    case FETCH_STUDENT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_STUDENT_SENT:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
